import { Button, CardProps, Col, Flex, Row, Tag, Typography } from 'antd';
import { Card } from '../Card';
import { SystemDescriptions } from 'src/common/descriptions';

type Props = {
    title: string;
    value: number | string;
    diff: number;
    asCurrency?: boolean;
    secondaryValueData?: string
    text: string
    hideDiff?: boolean
    onActionClick?: VoidFunction
} & CardProps;

const commonDescriptions = SystemDescriptions.PAGES.COMMON

export const StatsCard = ({
    diff,
    title,
    value,
    asCurrency,
    secondaryValueData,
    text,
    hideDiff,
    onActionClick,
    ...others
}: Props) => {
    return (
        <Card {...others}>
            <Flex vertical>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                }}  >
                    <Typography.Text className="text-capitalize m-0">
                        {title}
                    </Typography.Text>
                    {
                        onActionClick &&
                        <Button
                            color="default"
                            variant="link"
                            size='small'
                            style={{
                                fontSize: 12,
                                color: 'gray',
                            }}
                            onClick={onActionClick}
                        >
                            {commonDescriptions.ACTIONS.VIEW}
                        </Button>
                    }
                </div>
                <Row>
                    <Col span={24}>
                        <Typography.Title level={2}>
                            {typeof value === 'number' || typeof value === 'string' ? (
                                <>
                                    {asCurrency && <span>Q</span>} {value}
                                    {
                                        secondaryValueData &&
                                        <span style={{ fontSize: 13, fontWeight: 'normal', }}> / {secondaryValueData}</span>
                                    }
                                </>
                            ) : (
                                value
                            )}
                        </Typography.Title>
                    </Col>
                </Row>
                <Flex align="center">
                    {
                        !hideDiff &&
                        <Tag color={
                            diff < 30
                                ? 'red'
                                : diff < 60 ? 'yellow' : 'green'
                        }
                        >{diff}%</Tag>
                    }
                    <Typography.Text>{text}</Typography.Text>
                </Flex>
            </Flex>
        </Card>
    );
};